import { BrowserRouter, Link, Navigate, Route, Routes } from "react-router-dom";
import { publicRoutes, privateRoutes } from "../router";
import { useContext } from "react";
import { AuthContext } from "../context";
import Schema from "../pages/Schema";

const AppRouter = () => {
  console.log('appRouter');
  return (
    <Routes>
      {privateRoutes.map((route) => (
        <Route
        path={route.path}
        exact={route.exact}
        element={<route.component />}
        />
      ))}
       <Route path='*' element={<Navigate to="/page404" replace />}/>
    </Routes>
  )
};

export default AppRouter;
